import Component from 'component';
class GenericHero extends Component {
  constructor(el) {
    super(el);
    this.initHero();
  }

  initHero() {
    const _that = this;
    if (this.$el.next().hasClass('form-offer')){
      this.$el.addClass('generic-hero--offer-form');
    }

  }
}

export default GenericHero;




// WEBPACK FOOTER //
// ./src/btu/js/components/GenericHero.js